<template>
  <div>
    <v-card class="ml-1 mr-1 generic-card" style="border-radius: 20px; margin: 0; margin-top: 5px">
      <template v-if="generic">
        <div class="card-img">
          <uploadfile
            v-model="generic.image_url"
            :height="ratio == 'horizontal' ? 157 : 300"
            data-vv-as="Generic Image"
            :data-vv-name="'generic_manage_' + '_image'"
            @onUploaded="onUploaded"
            v-validate="isValidate ? 'required' : ''"
          ></uploadfile>
        </div>
        <div
          :class="{ 'has-error': errors.has('generic_manage_' + '_image') }"
          style="padding: 0 10px"
        >
          <span class="error--text caption" v-show="errors.has('generic_manage_' + '_image')">{{
            errors.first('generic_manage_' + '_image')
          }}</span>
        </div>

        <div class="card-body">
          <div
            :class="{ 'has-error': errors.has('generic_manage_' + '_title') }"
            style="padding: 5px"
          >
            <textarea
              name="title"
              id="title"
              style="
                width: 100%;
                resize: none;
                height: 50px;
                font-weight: 600;
                border-radius: 2px 2px 2px 0px !important;
              "
              maxlength="80"
              :data-vv-as="$t('Title')"
              :data-vv-name="'generic_manage_' + '_title'"
              class="form-control"
              v-model="generic.title"
              :placeholder="$t('Enter Title')"
              @change="$emit('input', generic)"
              v-validate="isValidate ? 'required' : ''"
            ></textarea>
            <span class="error--text caption" v-show="errors.has('generic_manage_' + '_title')">{{
              errors.first('generic_manage_' + '_title')
            }}</span>
          </div>
        </div>
      </template>

      <ul v-if="generic" class="list-group list-group-flush" style="margin-bottom: 0px">
        <li
          class="list-group-item"
          style="
            border-left: none;
            border-right: none;
            border-bottom: none;
            border-top: 1px solid #eee;
            border-radius: 0px;
            text-align: center;
          "
        ></li>
        <li
          class="list-group-item"
          style="
            border-left: none;
            border-right: none;
            border-bottom: none;
            border-top: 1px solid #eee;
            border-radius: 0px;
            text-align: center;
          "
        >
          <div style="padding: 10px 0">
            <span class="primary--text" style="padding: 15px 0; display: inline">
              {{ $t('receive_messages_every_day') }}
            </span>
          </div>
        </li>
      </ul>
    </v-card>
    <v-dialog v-model="showModal" persistent max-width="600px">
      <v-card>
        <div class="text-xs-right">
          <v-spacer></v-spacer>
          <v-btn flat icon small fab @click="showModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <h3>{{ $t('Link image url') }}</h3>
          <div class="text-xs-center">
            <v-radio-group
              color="primary"
              @select="onSelected"
              v-model="generic.notification_messages_frequency"
              row
              class="text-xs-center"
            >
              <v-radio color="primary" :label="$t('DAILY')" :value="'DAILY'"></v-radio>
              <v-radio color="primary" :label="$t('WEEKLY')" :value="'WEEKLY'"></v-radio>
              <v-radio color="primary" :label="$t('MONTHLY')" :value="'MONTHLY'"></v-radio>
            </v-radio-group>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import specialtext from '@/components/elements/specialtext'
import uploadfile from '@/components/elements/uploadfile'
import Multiselect from 'vue-multiselect'

export default {
  inject: ['$validator'],
  components: {
    specialtext,
    Multiselect,
    uploadfile
  },
  props: {
    value: {
      default: {}
    },
    isValidate: {
      default: false,
      type: Boolean
    },
    ratio: {
      default: 'square'
    }
  },
  data: function () {
    return {
      btnOptions: [
        {
          value: 'DAILY'
        },
        {
          value: 'WEEKLY'
        },
        {
          value: 'MONTHLY'
        }
      ],
      linktype: 'none',
      linkurl: '',
      isProductview: false,
      generic: this.value,
      showModal: false
    }
  },
  mounted: function () {
    this.generic.notification_messages_frequency = 'DAILY'
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    onSelected(param) {
      this.generic.notification_messages_frequency = param
    },

    onUploaded(url) {
      if (this.linktype == 'imglink') {
        this.$set(this.generic, 'default_action', {
          type: 'web_url',
          url: url
        })
        this.linkurl = url
      }
      this.$emit('onSave', this.generic)
    },

    onSave: function () {
      this.$emit('onSave', this.generic)
      this.showModal = false
    }
  },
  watch: {
    value: function () {
      this.generic = this.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/NtnManage.vue